import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ProductSkeletonHeader = Box.withConfig({
  backgroundColor: primitive.$blackOpacity4,
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
  height: {
    base: Styles.layout.navHeight.mobile,
    md: Styles.layout.navHeight.desktop,
  },
  paddingX: '$24',
});

export const ProductSkeletonCta = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
  height: 90,
  paddingX: '$4',
  borderTopWidth: 2,
  borderTopColor: primitive.$blackOpacity4,
});

export const ProductSkeletonButton = Box.withConfig({
  width: { base: 'full', md: '1/5' },
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: 1,
  borderColor: Styles.color.tertiary,
  borderRadius: 'full',
  height: '45px',
  paddingX: '$24',
});

export const ProductOverviewSkeletonContainer = Box.withConfig({
  height: {
    base: 400,
    md: 200,
  },
});

export const ProductInfoSkeletonContainer = Box.withConfig({
  flex: 1,
  paddingX: '$2',
  paddingY: '$4',
  backgroundColor: primitive.$blackOpacity4,
});

export const ProductContentSkeleton = Box.withConfig({
  width: 'full',
  paddingX: { base: '$0', md: '$64' },
  marginTop: { base: '$0', md: '$16' },
});

export const CloseBtnWrapper = Box.withConfig({
  position: 'absolute',
  right: '$4',
});
